import z from 'zod';
import { IFieldErrors, ValidationError } from 'src/types/validation';

const DistanceSchema = z.object({
  unit: z.string().min(1),
  distance: z.number().nonnegative()
});

export interface IDistance {
  unit: string;
  distance: number;
}

//update: Partial<IDistance>
export const getSchema = () => {
  return DistanceSchema;
};

export const validate = (update: Partial<IDistance>): IDistance => {
  const schema = getSchema();
  try {
    // Ensure there are changes from the original record
    const validated = schema.parse(update);
    return {
      ...validated
    };
  } catch (error: any) {
    if (error instanceof z.ZodError) {
      const errors: IFieldErrors = error.format();
      throw new ValidationError(errors);
    }
    throw new Error(error?.message || '');
  }
};